var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrowdsource(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.25C10.1756 12.25 12.75 9.67564 12.75 6.5C12.75 3.32436 10.1756 0.75 7 0.75C3.82436 0.75 1.25 3.32436 1.25 6.5C1.25 9.67564 3.82436 12.25 7 12.25Z",
    stroke: "#000",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1973 4.61157C7.82745 4.40332 7.40653 4.30315 6.98252 4.32248C6.55851 4.34182 6.14846 4.47987 5.79909 4.72092C5.44973 4.96196 5.17511 5.29631 5.00652 5.68584C4.83793 6.07538 4.78216 6.50443 4.84556 6.92412C4.90897 7.34381 5.08899 7.73725 5.36513 8.0596C5.64126 8.38195 6.00239 8.62025 6.40737 8.74733C6.81235 8.87442 7.24489 8.88518 7.65569 8.7784C8.06649 8.67162 8.43903 8.45158 8.73085 8.14336",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrowdsource);
export default __webpack_public_path__ + "static/media/crowdsource.b9015eca4f6186310760b0f793716b5e.svg";
export { ForwardRef as ReactComponent };